<template>
    <div>
        <page-title>编辑用户信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="form.mobile"/>
                </el-form-item>
                <el-form-item label="QQ号" prop="qq">
                    <el-input v-model="form.qq"/>
                </el-form-item>
                <el-form-item label="称呼" prop="name">
                    <el-input v-model="form.name"/>
                </el-form-item>
                <el-form-item label="管理员菜单" prop="menus" v-if="isAdmin">
                    <br>
                    <div class="menus-list" v-if="allMenus && allMenus.length">
                        <el-checkbox-group v-model="form.user_menus">
                            <div v-for="(item, index) in allMenus" :key="index" class="menus-item">
                                <el-checkbox :label="item.id">{{item.name}}</el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item label="设置密码">
                    <el-switch v-model="form.reset_password"/>
                    <el-input v-if="form.reset_password" v-model="form.password" placeholder="请输入新密码。"/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加站点'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<style scoped lang="scss">
    .host-ip-row {
        margin-top: 25px;
    }

    .host-ip-row:first-child {
        margin-top: 0;
    }

    .menus-list {
        border: 1px solid #DCDFE6;
        border-radius: 4px;

        .menus-item {
            padding: 0 20px;
            border-bottom: 1px solid #DCDFE6;
        }

        .menus-item:last-child {
            border-bottom: none;
        }
    }

</style>

<script>
import axios from '@/axios'

export default {
    name: 'Edit',
    data() {
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            isAdmin: false,
            allMenus: [],
            rules: {
                mobile: [
                    {required: true, message: '请填写手机号。'}
                ],
                qq: [
                    {required: true, message: '请填写QQ号。'}
                ],
                name: [
                    {required: true, message: '请填写称呼。'}
                ]
            },
            form: {
                id: null,
                mobile: '',
                qq: '',
                name: '',
                password: '',
                reset_password: false,
                user_menus: []
            }
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/user/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form.mobile = e.data.data.mobile
                    this.form.qq = e.data.data.qq
                    this.form.name = e.data.data.name
                    if (e.data.data.admin) {
                        this.form.user_menus = e.data.data.admin.user_menus
                        this.isAdmin = true
                        this.loadMenus()
                    }
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/user/update',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        loadMenus() {
            this.$request({
                url: 'admin/user/all-menus',
                params: {
                    user_id: this.form.id
                }
            }).then(e => {
                this.allMenus = e.data
            }).catch()
        }
    }
}
</script>
